// ======================================================================
// FILE: src/modules/wms/calendar/components/CalendarWorkdaysTab.js
// MODULE: Work Management System (WMS)
// FEATURE: Calendar Management
// COMPONENT: Workdays Tab
//
// PURPOSE:
//   Configure working and non-working days
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import wmsCalendarService
from "../../services/wmsCalendarService";

const DEFAULT_WORKDAYS = [
  {
    weekday_no: 1,
    weekday_name: "Monday",
    is_working_day: true,
  },
  {
    weekday_no: 2,
    weekday_name: "Tuesday",
    is_working_day: true,
  },
  {
    weekday_no: 3,
    weekday_name: "Wednesday",
    is_working_day: true,
  },
  {
    weekday_no: 4,
    weekday_name: "Thursday",
    is_working_day: true,
  },
  {
    weekday_no: 5,
    weekday_name: "Friday",
    is_working_day: true,
  },
  {
    weekday_no: 6,
    weekday_name: "Saturday",
    is_working_day: false,
  },
  {
    weekday_no: 7,
    weekday_name: "Sunday",
    is_working_day: false,
  },
];

export default function CalendarWorkdaysTab({
  calendarId,
}) {

  const [loading, setLoading] =
    useState(false);

  const [saving, setSaving] =
    useState(false);

  const [rows, setRows] =
    useState(DEFAULT_WORKDAYS);

  // ==========================================================
  // LOAD
  // ==========================================================

  async function loadData() {

    if (!calendarId) {
      return;
    }

    try {

      setLoading(true);

      const data =
        await wmsCalendarService
          .getWorkdays(calendarId);

      if (
        Array.isArray(data)
        && data.length > 0
      ) {

        setRows(data);

      } else {

        setRows(DEFAULT_WORKDAYS);
      }

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.message
        || "Failed to load workdays"
      );

    } finally {

      setLoading(false);
    }
  }

  useEffect(() => {

    loadData();

  }, [calendarId]);

  // ==========================================================
  // TOGGLE
  // ==========================================================

  function handleToggle(index) {

    const updated = [...rows];

    updated[index] = {
      ...updated[index],
      is_working_day:
        !updated[index].is_working_day,
    };

    setRows(updated);
  }

  // ==========================================================
  // SAVE
  // ==========================================================

  async function handleSave() {

    try {

      setSaving(true);

      await wmsCalendarService
        .saveWorkdays(
          calendarId,
          rows
        );

      alert(
        "Workdays saved successfully"
      );

      await loadData();

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.message
        || "Failed to save workdays"
      );

    } finally {

      setSaving(false);
    }
  }

  // ==========================================================
  // UI
  // ==========================================================

  if (!calendarId) {

    return (

      <div className="alert alert-info">

        Save calendar first
        before configuring workdays.

      </div>
    );
  }

  return (

    <div>

      <div className="card">

        <div className="card-header">

          <strong>
            Working Days Configuration
          </strong>

        </div>

        <div className="card-body">

          {loading ? (

            <div>
              Loading...
            </div>

          ) : (

            <table
              className="table table-bordered"
            >

              <thead>

                <tr>

                  <th width="100">
                    Day No
                  </th>

                  <th>
                    Day Name
                  </th>

                  <th width="200">
                    Working Day
                  </th>

                </tr>

              </thead>

              <tbody>

                {rows.map(
                  (
                    row,
                    index
                  ) => (

                    <tr
                      key={
                        row.weekday_no
                      }
                    >

                      <td>
                        {row.weekday_no}
                      </td>

                      <td>
                        {row.weekday_name}
                      </td>

                      <td>

                        <div
                          className="form-check"
                        >

                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={
                              row.is_working_day
                            }
                            onChange={() =>
                              handleToggle(
                                index
                              )
                            }
                          />

                        </div>

                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>

          )}

          <div className="mt-3">

            <button
              className="btn btn-primary"
              onClick={
                handleSave
              }
              disabled={
                saving
              }
            >

              {
                saving
                  ? "Saving..."
                  : "Save Workdays"
              }

            </button>

          </div>

        </div>

      </div>

    </div>
  );
}